import { execute } from '@/api/execute'
import { addQueryParams } from '@/util/index.js'

import companies from './companies'

const ENDPOINT = 'manager/deliveries'

export default {
  list (params = {}) {
    return execute('GET', addQueryParams(`${ENDPOINT}/`, params))
  },

  create (payload) {
    return execute('POST', `${ENDPOINT}/`, payload)
  },

  getById (id) {
    return execute('GET', `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute('PUT', `${ENDPOINT}/${id}/`, payload)
  },

  deleteById (id) {
    return execute('DELETE', `${ENDPOINT}/${id}/`)
  },

  companies
}
